import { useNavigate } from "react-router-dom";
import axios from "axios";
import uiStyles from '../UI/uistyles.module.css'

export default function DeleteAptButton(props) {

    const navigate = useNavigate();
    let urlDeleteAppointment = "https://gestiongarageplus.onrender.com/api/rendezVous/deleteRendezVous/" + props.aptDetails[0].idRendezVous;

    function handleDeleteAptButtonClick() {
        let answer = window.confirm("Veuillez cliquer sur OK pour confirmer la suppression du rendez-vous. Le rendez-vous sera supprimé définitivement.")
        if (answer) {
            axios.delete(urlDeleteAppointment, {})
            .then(response => {
                if (response.data.affectedRows > 0) {
                    alert("Rendez-vous supprimé avec succès!");
                    navigate("/");
                }
                else {
                    alert("Un problème est survenu lors de la suppression du rendez-vous.");
                }
            })
        }
    }

    return (
        <button
            className={uiStyles.deleteButton}
            type="button"
            value="Supprimer le rendez-vous"
            onClick={handleDeleteAptButtonClick}>
            <i class="fa-regular fa-trash-can"></i>
        </button>
    )
}